/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type IssueCardRequestType = typeof IssueCardRequestType[keyof typeof IssueCardRequestType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IssueCardRequestType = {
  physical: 'physical',
  virtual: 'virtual',
} as const;
